<template>
  <div class="w-full mb-10">
    <div class="flex items-center">
      <ebr-h2 :content="$t('tour_detail.booking.title')" :classes="'text-left ml-3'"/>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-5 my-5">
      <div v-for="price in tour.info.prices" :key="price.id"
        class="h-48 border border-gray-400 rounded-lg duration-200 hover:shadow-lg relative"
        :class="{'bg-parking-800 text-white': applyTabStyle(price.id)}"
        @click="selectPriceTab(price)">
        <div class="absolute top-0 right-0 bottom-0 left-0 mx-6 my-5 flex flex-col">
          <ebr-span class="self-start font-semibold text-xl" :content="price.title"/>
          <ebr-span
            class="self-start font-thin text-sm"
            :content="price.label"/>
          <ebr-span
            class="flex-grow text-xl flex justify-end items-end"
            :content="price.price"/>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
      <div class="col-span-2 lg:col-span-1 border border-gray-400
        rounded-lg flex items-center px-5 py-4">
        <ebr-span :content="$t('tour_detail.booking.form.date_field.label')" class="mr-4"/>
        <vue-pikaday
          v-model="now"
          :options="pikadayOptions"
          :placeholder="$t('tour_detail.booking.form.date_field.placeholder')"/>
      </div>
      <div class="col-span-2 lg:col-span-1  border border-gray-400
        rounded-lg flex items-center px-5 py-4">
        <ebr-span :content="$t('tour_detail.booking.form.hour_field.label')" class="mr-4"/>
        <ebr-select :showLabel="false" :id="'time'" :options="hourSelectOptions"
          @changed="hourSelected = $event" />
      </div>
      <!-- <div class="col-span-2 border border-gray-400 rounded-lg flex items-center px-5 py-4">
        <ebr-span :content="$t('tour_detail.booking.form.email_field.label')" class="mr-4"/>
        <ebr-input
          v-bind:value="email"
          v-on:input="email = $event"
          :type="'email'"
          :placeholder="$t('tour_detail.booking.form.email_field.placeholder')" />
      </div> -->
      <div class="col-span-2 border border-gray-400 rounded-lg flex items-center px-5 py-4">
        <ebr-span :content="$t('tour_detail.booking.form.seat_field.label')" class="mr-4"/>
        <ebr-select :showLabel="false" :id="'seats'" :options="seatsSelectOptions"
        @changed="seatSelected = $event" />
      </div>
      <div class="col-span-2 flex items-center lg:justify-end px-5 py-4">
        <ebr-round-button-link
            :href="mailto"
            :label="$t('shared.strings.bookNow')"
            class="text-xs md:text-sm lg:text-md w-full lg:w-auto
            bg-parking-900 text-white hover:bg-parking-700 mb-4 md:mb-0"/>
      </div>
    </div>
  </div>
</template>

<script>
import '@enrian/vue-pikaday';
import '@enrian/vue-pikaday/dist/vue-pikaday.min.css';
import moment from 'moment';

import H2Vue from '../../atoms/typography/H2.vue';
import SpanVue from '../../atoms/typography/Span.vue';
import SelectVue from '../../atoms/inputs/Select.vue';
import RoundButtonLinkVue from '../../atoms/buttons/RoundButtonLink.vue';

export default {
  data() {
    return {
      // email: '',
      tabSelected: null,
      now: null,
      pikadayOptions: {
        format: 'DD MMMM YYYY',
        minDate: moment().toDate(),
        value: moment().toDate(),
      },
      hourSelected: '',
      hourSelectOptions: [
        {
          value: '09:00',
          text: '09:00',
        },
        {
          value: '10:00',
          text: '10:00',
        },
        {
          value: '11:00',
          text: '11:00',
        },
        {
          value: '12:00',
          text: '12:00',
        },
        {
          value: '13:00',
          text: '13:00',
        },
        {
          value: '14:00',
          text: '14:00',
        },
        {
          value: '15:00',
          text: '15:00',
        },
        {
          value: '16:00',
          text: '16:00',
        },
        {
          value: '17:00',
          text: '17:00',
        },
        {
          value: '18:00',
          text: '18:00',
        },
      ],
      seatSelected: '',
      seatsSelectOptions: [
        {
          value: 1,
          text: '1 Persona',
        },
        {
          value: 2,
          text: '2 Persone',
        },
        {
          value: 3,
          text: '3 Persone',
        },
        {
          value: 4,
          text: '4 Persone',
        },
      ],
    };
  },
  props: {
    tour: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isPriceChecked() {
      return this.$store.state.isPriceChecked;
    },
    mailto() {
      const { selectedPrice } = this.$store.state;
      return `mailto:info@easyboatrentdesenzano.it?subject=${this.$t('messages.tour.mail.subject1')} ${this.tour.info.title} ${this.$t('messages.tour.mail.subject2')} ${moment(this.now).format('L')}&body=${this.$t('messages.tour.mail.body1')} ${this.tour.info.title} ${this.$t('messages.tour.mail.body2')} ${moment(this.now).format('L')} ${this.$t('messages.tour.mail.body3')} ${this.hourSelected} ${this.$t('messages.tour.mail.body4')} ${this.seatSelected} ${this.$t('messages.tour.mail.body5')} ${selectedPrice.price}.%0D%0A%0D%0A[${this.$t('messages.tour.mail.body6')}]`;
    },
  },
  methods: {
    selectPriceTab(element) {
      if (this.tabSelected === element.id) {
        this.$store.commit('togglePriceChecked');
        this.$store.commit('selectPrice', '');
      } else {
        this.tabSelected = element.id;
        this.$store.commit('checkPrice');
        this.$store.commit('selectPrice', element);
      }
    },
    applyTabStyle(selectedId) {
      return this.tabSelected === selectedId && this.isPriceChecked;
    },
  },
  components: {
    'ebr-h2': H2Vue,
    'ebr-span': SpanVue,
    'ebr-select': SelectVue,
    'ebr-round-button-link': RoundButtonLinkVue,
  },
};
</script>

<style>

</style>
